import { useState, useMemo, useCallback } from 'react';

export type ContextMenuPosition = {
  mouseX: number;
  mouseY: number;
};

type ContextMenu = ContextMenuPosition | null;

export function useContextMenu(): {
  contextMenu: ContextMenu;
  handleClose: () => void;
  handleContextMenu: (event: MouseEvent) => void;
} {
  const [contextMenu, setContextMenu] = useState<ContextMenu>(null);

  const handleContextMenu = useCallback((event: MouseEvent) => {
    setContextMenu((prev) => {
      return prev === null
        ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 }
        : null;
    });
  }, []);

  const handleClose = useCallback(() => {
    setContextMenu(null);
  }, []);

  return useMemo(
    () => ({ contextMenu, handleContextMenu, handleClose }),
    [contextMenu, handleClose, handleContextMenu]
  );
}
